import React, { useState } from "react";
import styled from "@emotion/styled";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import SmallButtonSpinner from "@components/SmallButtonSpinner";
import { useDispatch, useSelector } from "react-redux";
import { sendVerification } from "./thunk";
import { selectedPhone } from "./selector";

const NotifyContainer = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
`;

const NotifyButtons = ({ type, orderUUID }) => {
  const dispatch = useDispatch();
  const selectedPhoneNumberId = useSelector(
    state => state.orderVerification.selectedPhoneNumberId
  );
  const theSelectedPhone = useSelector(state => selectedPhone(state));

  const disabled = selectedPhoneNumberId ? false : true;
  const [loadSpinner, setLoadSpinner] = useState(false);

  const handleClick = async validationType => {
    if (disabled) {
      return;
    }
    setLoadSpinner(validationType);
    await dispatch(
      sendVerification({
        type,
        validationType,
        selectedPhone: theSelectedPhone,
        orderUUID
      })
    );
  };

  return (
    <NotifyContainer className="notify-container">
      <DefaultOrangeButton
        handleClick={() => handleClick("sms")}
        disabled={disabled}
        classes={"main-default-orange-button"}
      >
        {loadSpinner === "sms" ? (
          <SmallButtonSpinner img="https://cdn.cardcash.com/website/ui/elements/spinner-white.png" />
        ) : (
          <span>Text</span>
        )}
      </DefaultOrangeButton>
      <DefaultOrangeButton
        handleClick={() => handleClick("call")}
        disabled={disabled}
        classes={"main-default-orange-button"}
      >
        {loadSpinner === "call" ? (
          <SmallButtonSpinner img="https://cdn.cardcash.com/website/ui/elements/spinner-white.png" />
        ) : (
          <span>Call</span>
        )}
      </DefaultOrangeButton>
    </NotifyContainer>
  );
};

export default NotifyButtons;
